import React from 'react';
import {
  Box, Button, VStack, Text, HStack, useColorModeValue, Divider, Tooltip,
} from "@chakra-ui/react";
import { Link, useLocation } from 'react-router-dom';
import { FaRegCalendarAlt, FaUserAlt, FaFileAlt, FaClipboard, FaChalkboardTeacher, FaLifeRing } from "react-icons/fa";
import PrivateSidebarLayout from '../Common/PrivateSidebarLayout';
import { useTenant } from "../Routers/TenantContextProvider";
import { usePlatformSidebar } from "../Common/PrivateSidebarContext";

const StudentSideBar = () => {
  const { tenant } = useTenant();
  const { isCollapsed } = usePlatformSidebar();
  const location = useLocation();

  const hoverBg = useColorModeValue("gray.100", "gray.700");

  const renderNavLink = (to: string, label: string, icon: React.ReactElement) => {
    const isActive = location.pathname === to;

    const button = (
      <Button
        as={Link}
        to={to}
        justifyContent={isCollapsed ? "center" : "flex-start"}
        variant="ghost"
        size="sm"
        pl={isCollapsed ? 0 : 4}
        py={5}
        borderRadius="lg"
        bg={isActive ? hoverBg : "transparent"}
        _hover={{ bg: hoverBg }}
        fontWeight={isActive ? "semibold" : "medium"}
        w="100%"
      >
        <HStack spacing={isCollapsed ? 0 : 3}>
          {icon}
          {!isCollapsed && <Text fontSize="sm">{label}</Text>}
        </HStack>
      </Button>
    );

    return isCollapsed ? (
      <Tooltip label={label} placement="right" hasArrow>
        {button}
      </Tooltip>
    ) : button;
  };

  return (
    <PrivateSidebarLayout>
      <Box px={isCollapsed ? 1 : 3} py={4} mt={10}>
        <VStack align="stretch" spacing={1}>
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/student-calendar`, "My Calendar", <FaRegCalendarAlt />)}
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/student-profile`, "My Profile", <FaUserAlt />)}

          <Divider my={2} />

          {/* Single entry point into course content — the tree/viewer live here now, not in the sidebar */}
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/student-batches`, "Course Dashboard", <FaChalkboardTeacher />)}

          <Divider my={2} />

          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/student-exams`, "Upcoming Exams", <FaFileAlt />)}
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/student-exam-attempts`, "Exam Results", <FaFileAlt />)}
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/student-assignments`, "My Assignments", <FaClipboard />)}
          {renderNavLink(`/platform/${tenant?.tenant_slug}/app/student-support`, "Support", <FaLifeRing />)}
        </VStack>
      </Box>
    </PrivateSidebarLayout>
  );
};

export default StudentSideBar;